module.exports = __webpack_public_path__ + "static/media/26.47b1bc53.mp3";